module.exports = __webpack_public_path__ + "img/4_en.97a62a94.jpg";